// A scene's table (…/mapas/<id>/mesa) or the one waiting between scenes (…/mapas/mesa).
const TABLE_PATH = /\/mapas\/(?:[^/]+\/)?mesa$/;

// A table window already open keeps its page and only comes forward.
// Reuses the named window when the table is already open. A blocked popup
// still opens the table somewhere; a window that navigated away from the
// table, or to another origin it cannot read, is sent back to it.
export function openTable(href: string, campaignId: string) {
	const popup = window.open("", `mesa-${campaignId}`, "popup,width=1280,height=720");
	if (!popup) {
		if (!window.open(href, "_blank")) window.location.assign(href);
		return;
	}
	let onTable = false;
	try {
		onTable = TABLE_PATH.test(new URL(popup.location.href).pathname);
	} catch {}
	if (!onTable) popup.location.href = href;
	popup.focus();
}
